import { PropsWithChildren } from 'react';
import { Keyboard, TouchableWithoutFeedback } from 'react-native';

export const KeyboardDismissView = ({ children }: PropsWithChildren) => (
	<TouchableWithoutFeedback onPress={Keyboard.dismiss} accessible={false}>
		{children}
	</TouchableWithoutFeedback>
);
